import { HTMLAttributes, ReactNode } from 'react';

import styles from './ControlBtnLink.module.css';

type Props = {
  href: string;
  children: ReactNode;
};

function ControlBtnLink({
  children,
  className = '',
  href,
  ...props
}: Props & HTMLAttributes<HTMLAnchorElement>) {
  return (
    <a
      className={`${styles['control-btn-link']} ${className}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  );
}

export default ControlBtnLink;
